<template>

  <div class="home-wrap">
    <img class="top-img" src="../../../assets/imgs/banner2.jpeg">
    <div class="contact-us-wrap">
      <div class="left-wrap">

        <div class="head-txt">
          新闻中心
        </div>
        <div @click="qiehuanTab(index)" :class="currTab == index ?'item-txt item-txt-select':'item-txt'"
             v-for="(txt, index) in menuList">
          {{ txt.text }}
        </div>
      </div>

      <div class="right-wrap">

        <div style="width: 100%;height: 1px;background-color: #333333"></div>

        <div class="text-title">
          当前位置：
          <div class="a-a" @click="goHome">首页</div>
          > 新闻中心 > {{ menuList[currTab].text }}
          <img class="c-us" src="../../../assets/imgs/serve-phone.png">
          <div class="c-line"></div>
        </div>

        <template v-if="newsList.length==0">
          <empty-layout @emptyClick="onLoad" :state="emptyState"/>
        </template>
        <template v-else>
          <div style="height: 40px"></div>

          <div class="news-item" v-for="(item,index) in newsList" @click="xinwenItem($event,item)">
            <div class="info-wrap">
              <div class="title">{{ item.title }}</div>
              <div class="desc">{{ item.subtitle }}</div>
              <div class="time">{{ item.time }}</div>
            </div>
            <div class="img-wrap">
              <img class="news-img" v-lazy="item.head_img">
            </div>
          </div>
          <div style="height: 40px"></div>
        </template>
        <div class="my-page"></div>
        <div style="height: 40px"></div>
      </div>
    </div>
  </div>

</template>

<script>
import EmptyLayout from "@/pages/main/fragment/EmptyLayout";
import {Lazyload} from 'vant';
import Vue from 'vue';
import cache from "@/utils/cache";
import {Toast} from 'vant';

Vue.use(Toast);
Vue.use(Lazyload);
export default {
  name: "anliYjFragment",
  components: {EmptyLayout},
  data: () => {
    return {
      currTab: 0,
      currPage: 1,
      totalPage: 0,
      newsList: [],
      loading: false,
      emptyState: 0,
      menuList: [{
        text: '公司动态',
        id: 'asu9wkeg9blk'
      }, {
        text: '行业新闻',
        id: 'asr8vcii1mprx'
      }]
    }
  },
  mounted() {
    this.onLoad()
  },
  methods: {
    goHome() {
      this.$router.replace('/home')
    },
    qiehuanTab(i) {
      if (this.currTab == i)
        return
      this.currTab = i

      this.newsList = []
      this.currPage = 1
      this.onLoad()
    },
    async onLoad() {
      this.emptyState = 0

      Toast.loading({
        duration: 0, // 持续展示 toast
        forbidClick: true,
        message: '...'
      });
      let data = {
        PageNum: this.currPage,
        postion: this.menuList[this.currTab].id
      }
      let res = await this.$store.dispatch('post', {url: "article", data: data}).catch(err => {
        Toast.fail(err.message)
      })

      if (res) {
        let list = res.data.data
        this.totalPage = res.data.pageCount
        let that = this
        myPageInit({
          pages: this.totalPage,
          currentPage: this.currPage,
          element: '.my-page',
          callback: function (page) {
            console.log(page)
            if (page && that.currPage != page) {
              that.currPage = page
              that.onLoad()
            }
          }
        });
        if (list != null && list.length > 0) {
          this.newsList = list
        } else {
          this.emptyState = 2
        }
        this.finished = true
      } else {
        this.emptyState = 1;
      }

      this.loading = false
    },
    xinwenItem(e, item) {//新闻
      const {href} = this.$router.resolve({
        path: '/newsDetail',
        name: 'newsDetailPage',
      });
      cache.setSession('itemnews', item)
      window.open(href, "_blank");
    },
  }
}
</script>

<style lang="less" scoped>
.home-wrap {

  display: flex;
  width: 1400px;
  min-width: 100%;
  align-items: center;
  background-color: white;
  flex-direction: column;

  .top-img {
    width: 100%;
    min-width: 100%;
  }

}

.contact-us-wrap {
  width: min-content;
  min-height: 100%;
  padding-top: 10px;
  min-width: 100%;
  display: flex;
  background-color: white;
  justify-content: center;

  .left-wrap {
    width: 230px;
    display: flex;
    flex-direction: column;

    .head-txt {
      background-color: #063979;
      width: 100%;
      height: 60px;
      line-height: 60px;
      color: white;
      font-size: 18px;
      padding-left: 20px;
    }

    .item-txt {
      width: 100%;
      background-color: #DEDFE0;
      padding-left: 20px;
      font-size: 16px;
      height: 50px;
      line-height: 50px;
      color: #666666;
      margin-top: 2px;
    }

    .item-txt-select {
      color: #143772;
      border-bottom: 1px #143772 solid;
    }
  }

  .right-wrap {
    display: flex;
    flex-direction: column;
    width: 970px;
    margin-left: 10px;

    .text-title {
      color: #666666;
      font-size: 16px;
      display: flex;
      height: 34px;
      align-items: center;
      position: relative;

      .c-us {
        position: absolute;
        right: 0;
        bottom: 0;
      }

      .a-a {
        margin-left: 5px;
        margin-right: 5px;
        font-size: 16px;
        color: #666666;
      }

      .a-a:hover {
        text-decoration: underline;
        color: #22B5A8;
      }

      .c-line {
        background-color: #333333;
        height: 1px;
        position: absolute;
        bottom: 0;
        left: 0;
        right: 20px;
      }
    }

    .news-item {
      background-color: #F3F4F5;
      width: 100%;
      display: flex;
      height: 180px;
      padding: 20px;
      margin-top: 10px;
      align-items: center;
      flex-direction: row;

      .info-wrap {
        flex: 1;
        display: flex;
        height: 100%;
        justify-content: space-between;
        flex-direction: column;

        .title {
          color: #063979;
          font-size: 18px;
        }

        .desc {
          color: #333333;
          font-size: 16px;
        }

        .time {
          color: #333333;
          font-size: 14px;
        }
      }

      .img-wrap {
        width: 160px;
        height: 104px;
        margin-right: 10px;
        overflow: hidden;
        border: white solid 3px;

        .news-img {
          width: 160px;
          min-height: 100%;
        }
      }

    }

    .news-item:hover {
      .img-wrap {
        width: 160px;
        height: 104px;
        margin-right: 10px;
        border: #FFE92C solid 3px;

        .news-img {
          transition: All 0.4s ease-in-out;
          transform: scale(1.2);
        }

      }
      .info-wrap .title {
        color: green;
      }
    }
  }
}
</style>
